import { render, staticRenderFns } from "./BulkAddEmployees.vue?vue&type=template&id=72ac3cd2&scoped=true&"
import script from "./BulkAddEmployees.vue?vue&type=script&lang=js&"
export * from "./BulkAddEmployees.vue?vue&type=script&lang=js&"
import style0 from "./BulkAddEmployees.vue?vue&type=style&index=0&id=72ac3cd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac3cd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardTitle,VContainer,VIcon})
